<template>
    <DataView :value="['', '', '']" :layout="'grid'" data-key="id">
        <template #header>
            <div class="flex justify-end">
                <SelectButton :allow-empty="false">
                    <template #option="{ option }">
                        <i :class="[option === 'list' ? 'pi pi-bars' : 'pi pi-th-large']" />
                    </template>
                </SelectButton>
            </div>
        </template>

        <template #list>
            <div class="w-full">
                <div class="flex flex-col xl:flex-row xl:items-start p-6 gap-6">
                    <Skeleton class="w-3/4 sm:w-64 xl:w-40 shadow-md h-24 block xl:block mx-auto rounded" />
                    <div
                        class="flex flex-col sm:flex-row justify-between items-center xl:items-start flex-1 gap-6"
                    >
                        <div class="flex flex-col items-center sm:items-start gap-4">
                            <Skeleton class="w-32 rounded h-8" />
                            <Skeleton class="w-24 rounded h-4" />
                            <div class="flex items-center gap-4">
                                <Skeleton class="w-24 rounded h-4" />
                                <Skeleton class="w-12 rounded h-4" />
                            </div>
                        </div>
                        <div class="flex sm:flex-col items-center sm:items-end gap-4 sm:gap-2">
                            <Skeleton class="w-16 rounded h-8" />
                            <Skeleton shape="circle" class="w-12 h-12" />
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <template #grid>
            <div class="w-full sm:w-1/2 lg:w-full xl:w-1/3 p-2">
                <div class="p-6 border border-border-ui bg-surface rounded">
                    <div class="flex flex-wrap items-center justify-between gap-2">
                        <Skeleton class="w-24 rounded h-8" />
                        <Skeleton class="w-12 rounded h-4" />
                    </div>
                    <div class="flex flex-col items-center gap-4 py-8">
                        <Skeleton class="w-3/4 shadow-md rounded h-40" />
                        <Skeleton class="w-32 rounded h-8" />
                        <Skeleton class="w-24 rounded h-4" />
                    </div>
                    <div class="flex items-center justify-between">
                        <Skeleton class="w-16 rounded h-8" />
                        <Skeleton shape="circle" class="w-12 h-12" />
                    </div>
                </div>
            </div>
        </template>
    </DataView>
</template>
